export const VIEWER_REPORT_NOMDAY_MODEL_LIST = 'VIEWER_REPORT_NOMDAY_MODEL_LIST'
export const VIEWER_REPORT_NOMDAY_SEARCH = 'VIEWER_REPORT_NOMDAY_SEARCH'
export const VIEWER_REPORT_NOMDAY_PAGINATION = 'VIEWER_REPORT_NOMDAY_PAGINATION'
export const VIEWER_REPORT_NOMDAY_DROP_DOWN_SEARCH_TYPE = 'VIEWER_REPORT_NOMDAY_DROP_DOWN_SEARCH_TYPE'
